import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import ImageWrapper from './ImageWrapper';
import PublishedByWrapper from './PublishedByWrapper';
import StyledImg from './StyledImg';
import StyledTypography from './StyledTypography';

export type PublishedByContentProps = React.HTMLAttributes<HTMLDivElement> & {
  sellerLogo?: string;
  sellerName: string;
};

const PublishedByContent: React.FC<PublishedByContentProps> = ({
  sellerLogo,
  sellerName,
  ...rest
}) => {
  return (
    <React.Fragment>
      {sellerLogo && (
        <ImageWrapper>
          <StyledImg
            src={sellerLogo}
            alt={`${sellerName} logo`}
          />
        </ImageWrapper>
      )}
      <PublishedByWrapper {...rest}>
        <Typography
          variant='small'
          weight='light'
        >
          Publicado por
        </Typography>
        <StyledTypography
          variant='body2'
          weight='regular'
          color='midnightBlue'
        >
          {sellerName}
        </StyledTypography>
      </PublishedByWrapper>
    </React.Fragment>
  );
};

export default PublishedByContent;
